import en from '../../../lang/en/en.json';
import es from '../../../lang/es/es.json';
import pt from '../../../lang/pt/pt.json';
import ca from '../../../lang/ca/ca.json';

const availableTranslations = { en, es, pt, ca };

// Language whose lines stand in for a missing one, as in config/language.php.
const fallbackLanguages = { ca: 'es' };

let currentLocale = 'en';

function findLine(locale, key) {
  let value = availableTranslations[locale] || {};
  for (const part of key.split('.')) {
    if (value && value[part] !== undefined) {
      value = value[part];
    } else {
      return undefined;
    }
  }

  return typeof value === 'object' ? undefined : value; // avoid returning an object accidentally
}

export function __(key, replacements = {}) {
  let value = findLine(currentLocale, key);
  if (value === undefined && fallbackLanguages[currentLocale]) {
    value = findLine(fallbackLanguages[currentLocale], key);
  }

  if (value === undefined) {
    if (process.env.NODE_ENV === 'development') {
      console.warn(`Missing translation: ${key}`);
    }
    return key;
  }

  // Replace placeholders (e.g., :name)
  for (const [k, v] of Object.entries(replacements)) {
    value = value.replace(new RegExp(`:${k}`, 'g'), v);
  }

  return value;
}

/**
 * Change the active locale (default: 'en')
 */
export function setLocale(locale) {
  if (availableTranslations[locale]) {
    currentLocale = locale;
  } else {
    console.warn(`Locale '${locale}' not found. Falling back to 'en'.`);
    currentLocale = 'en';
  }
}

if (typeof window !== 'undefined') {
  window.__ = __;
  window.setLocale = setLocale;
}
